<div id="mobile-likes-list">
  <kl-likes-list [shareId]="id" (viewProfilePage)="profilePageOpen()"></kl-likes-list>
</div>
